import type { TabItem } from '../../../components/ui/index.js';

export const EMPLOYEE_TAB_IDS = ['work', 'outputs', 'decisions', 'perf', 'perms', 'convo'] as const;
export type EmployeeTab = (typeof EMPLOYEE_TAB_IDS)[number];

const LABELS: Record<EmployeeTab, string> = {
  work: 'Current work',
  outputs: 'Outputs',
  decisions: 'Decisions',
  perf: 'Performance',
  perms: 'Permissions',
  convo: 'Conversation',
};

/** The employee detail tab strip; a count shows only for the tabs that list rows. */
export function employeeTabs(counts: Partial<Record<EmployeeTab, number>>): TabItem[] {
  return EMPLOYEE_TAB_IDS.map((id) => ({ id, label: LABELS[id], count: counts[id] }));
}
